import { standard } from '../../constants';

export default {
  ...standard('CREATE', 'scores'),
  ...standard('DELETE', 'scores'),
  ...standard('GET', 'scores'),
  ...standard('UPDATE', 'scores'),
};



// WEBPACK FOOTER //
// ./src/modules/scores/constants.js